import type { Admin, CurrentAdminRbacV2Grant } from '@gozoki/api-types'
import type { Right } from '@gozoki/tools'
import { createContext } from 'react'

export interface AuthContextType {
  authenticated: boolean
  user: Admin | null
  isLoading: boolean
  logout: () => Promise<void>
  /**
   * Bits hérités `adminRights` : ils ne décident plus rien, les deux rendent toujours faux. Ils
   * restent le temps que leurs derniers sites d'appel, tous dans des branches « flag OFF » mortes,
   * disparaissent.
   */
  hasRights: (rights: Right[]) => boolean
  hasOneRight: (rights: Right[]) => boolean
  rbacLoading: boolean
  /** Grants v2 du contrat retenu par `resolveRbacSession`, ceux dont l'ability est construite. */
  rbacGrantsV2: CurrentAdminRbacV2Grant[]
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  hasRights: () => false,
  hasOneRight: () => false,
  isLoading: false,
  rbacLoading: false,
  rbacGrantsV2: [],
  logout: async () => {},
  user: null,
})
